import config from "react-global-configuration";
import "config";

export const getConfiguration = (settingName:string) => {
  return config.get(settingName);
};

export const getConfigurationBaseUrl = () => {
  return config.get("baseUrl");
};

export const getTimePhasingApiUrl = () => {
  return config.get("timePhasingApirUrl");
};


export const getTermsAndUsePdfUrl = () => {
  return config.get("termsAndUsePdfUrl");
};

export const getPrivacyPolicyPdfUrl = () => {
  return config.get("privacyPolicyPdfUrl");
};
